import { createWebHashHistory, createRouter } from "vue-router";
import store from "@/store";

// Main pages
import Layout from "@/components/Layouts/Index.vue";
import Login from "@/components/Authentication/Login/LoginForm.vue";
import Home from "@/components/Dashboard/Index.vue";

// ✅ IMPORTAR LAS VISTAS PÚBLICAS (Políticas y Términos)
import PrivacyPolicy from "@/components/Policies/PrivacyPolicy.vue";
import TermsConditions from "@/components/Policies/TermsConditions.vue"; // <--- NUEVO
import ActivateAccount from "@/views/Security/ActivateAccount.vue"; // <--- NUEVO
import ForgotPassword from "@/components/Authentication/ForgotPassword/ForgotPassword.vue";
// Routers (Módulos)
import configurationRouter from "./modules/configuration/configuration";
import securityRouter from "./modules/security/security";
import locationRouter from "./modules/location/location";
import aulaRouter from "./modules/aula/aula";
import templateRouter from "./modules/template/template";
import enrollmentRouter from "./modules/enrollments/enrollment";
import collectionRouter from "./modules/collection/collection";
import systemAdministrationRouter from "./modules/administration/administration";
import academicRouter from "./modules/academic/academic";
import academicBaseRouter from "./modules/academic-base/academic-base";
import preschoolRouter from "./modules/preschool/preschool";
import piarRouter from "./modules/piar/piar";
import reportsRouter from "./modules/reports/reports";

const constantRouterMap = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  // ✅ RUTAS PÚBLICAS
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/terms-conditions",  // <--- NUEVA RUTA
    name: "TermsConditions",
    component: TermsConditions,
  },
  {
    path: "/activate-account",  // <--- NUEVA RUTA
    name: "ActivateAccount",
    component: ActivateAccount,
  },
  {
    path: "/forgot-password",  // <--- NUEVA RUTA
    name: "ForgotPassword",
    component: ForgotPassword,
  },

  {
    path: "/",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "home",
        name: "HomeInit",
        component: Home,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

export const asyncRouterMap = [
  configurationRouter,
  securityRouter,
  locationRouter,
  aulaRouter,
  templateRouter,
  systemAdministrationRouter,
  enrollmentRouter,
  collectionRouter,
  academicRouter,
  academicBaseRouter,
  preschoolRouter,
  piarRouter,
  reportsRouter
];

const router = createRouter({
  history: createWebHashHistory(),
  linkExactActiveClass: "active",
  routes: [...constantRouterMap, ...asyncRouterMap],
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

// Guard de navegación (Seguridad)
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];

  // ✅ LÓGICA ACTUALIZADA:
  // Definimos una lista de páginas que NO requieren login
  const publicPages = ["Login", "PrivacyPolicy", "TermsConditions", "ActivateAccount", "ForgotPassword"];

  // Si la página a la que vas NO está en la lista pública Y no estás logueado...
  if (!publicPages.includes(to.name as string) && !isAuthenticated) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;